import React from 'react';
import PropTypes from 'prop-types';

const ColorPickerIcon = ({ fill }) => (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <desc>Created with Sketch.</desc>
        <defs>
            <path d="M5.77583333,0.166666667 L14.5877579,0.166666667 L10.1666667,4.58775792 L5.77583333,0.166666667 Z M16.5833333,4.75 C16.5833333,3.53083333 18.4166667,1.32756114 18.4166667,1.54166667 C18.4166667,1.54166667 20.25,3.53083333 20.25,4.75 C20.25,5.75833333 19.425,6.58333333 18.4166667,6.58333333 C17.4083333,6.58333333 16.5833333,5.75833333 16.5833333,4.75 Z M0.666666667,9.33333333 L23.3333333,9.33333333 L23.3333333,13.8333333 L0.666666667,13.8333333 L0.666666667,9.33333333 Z" id="path-1" />
            <path d="M16.18,8.195 C16.7208333,8.73583333 16.7208333,9.60666667 16.18,10.1383333 L11.1383333,15.18 C10.8725,15.4458333 10.515,15.5833333 10.1666667,15.5833333 C9.81833333,15.5833333 9.46083333,15.4458333 9.195,15.18 L4.15333333,10.1383333 C3.6125,9.60666667 3.6125,8.73583333 4.15333333,8.195 L8.87416667,3.47416667 L6.6925,1.2925 L7.985,1.45661261e-13 L16.18,8.195 Z M14.5575,9.16666667 L10.1666667,4.77583333 L5.77583333,9.16666667 L10.1666667,13.5877579 L14.5877579,9.16666667 L14.5575,9.16666667 Z M0.666666667,18.3333333 L23.3333333,18.3333333 L23.3333333,22.8333333 L0.666666667,22.8333333 L0.666666667,18.3333333 Z M1.66666667,19.3333333 L1.66666667,21.8333333 L22.3333333,21.8333333 L22.3333333,19.3333333 L1.66666667,19.3333333 Z" id="path-3" />
        </defs>
        <g id="icon-color-fill" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Icons-/-Custom-/-Color-Fill" transform="translate(-4.000000, -4.000000)">
                <g id="color-fill" transform="translate(4.000000, 5.000000)">
                    <g id="icon-colors" transform="translate(0.000000, 9.000000)">
                        <mask id="mask-2" fill="white">
                            <use href="#path-1" />
                        </mask>
                        <use id="Mask" fill="black" href="#path-1" />
                        <g data-test-id="color-picker-icon-group" id="Colour-/-color-nav-yellow" mask="url(#mask-2)" fill={fill} fillRule="nonzero">
                            <g transform="translate(-4.000000, -14.000000)" id="base_color">
                                <rect x="0" y="0" width="32" height="32" />
                            </g>
                        </g>
                    </g>
                    <g id="icon-outline">
                        <mask id="mask-4" fill="white">
                            <use href="#path-3" />
                        </mask>
                        <use data-test-id="color-picker-icon-use" id="Mask" fill={fill} href="#path-3" />
                        <g id="Colour-/-color-gray-700-Subtitles" mask="url(#mask-4)" fill="#727273" fillRule="nonzero">
                            <g transform="translate(-4.000000, -5.000000)" id="base_color">
                                <rect x="0" y="0" width="32" height="32" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

ColorPickerIcon.propTypes = {
    fill: PropTypes.string.isRequired,
};

export default ColorPickerIcon;
